export default __webpack_public_path__ + "static/operator@2x-d0ac826e542bdcddb31576b9b02c0228.png";